import { BigNumber } from '@ethersproject/bignumber';
import { useCallback } from 'react';
import { useSendTransaction, useWriteContract } from 'wagmi';

import { ERC20 } from 'shared/abi';
import { useTypedSelector } from 'store';

const useERC20Deposit = (tokenAddress: string) => {
  const { writeContractAsync } = useWriteContract();

  const dexPair = useTypedSelector(store => store.pairs.selectedDexPair)!;

  const { sendTransactionAsync } = useSendTransaction();

  const deposit = useCallback(
    async ({ walletAddress, amount }: { walletAddress: string; amount: BigNumber }) => {
      const baseTokenAddress = dexPair.token_base.address.toLowerCase();
      const quoteTokenAddress = dexPair.token_quote.address.toLowerCase();

      const isContractWithMainAsset = ![baseTokenAddress, quoteTokenAddress].includes(
        tokenAddress.toLowerCase(),
      );

      //TODO extend contract types
      try {
        const result = isContractWithMainAsset
          ? await sendTransactionAsync({ to: walletAddress as any, value: amount.toBigInt() })
          : await writeContractAsync({
              address: tokenAddress as any,
              abi: ERC20,
              functionName: 'transfer',
              args: [walletAddress, amount.toBigInt()],
            });

        return result;
      } catch (error) {
        // Workaround for Rolldown bundling issue: instanceof checks can fail in production
        // Check error by name instead of instanceof to avoid "Right-hand side of 'instanceof' is not an object"
        const errorName =
          error && typeof error === 'object' && 'name' in error
            ? (error as { name: string }).name
            : '';
        const errorMessage =
          error && typeof error === 'object' && 'message' in error
            ? String((error as { message: unknown }).message)
            : String(error);

        console.error('[useERC20Deposit] Transaction error:', {
          name: errorName,
          message: errorMessage,
          error,
        });

        // Re-throw the error so callers can handle it
        throw error;
      }
    },
    [tokenAddress, dexPair, sendTransactionAsync, writeContractAsync],
  );

  return {
    deposit,
  };
};

export { useERC20Deposit };
